import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PlaceProductsPage } from './place-products.page';

const routes: Routes = [
    {
        path: '',
        component: PlaceProductsPage,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PlaceProductsPageRoutingModule {}
